const restaurant = {
  restaurant: "Εστιατόριο", // translated
  restaurants: "Εστιατόρια", // translated
  category: "Κατηγορία", // translated
  score: "Σκορ", // translated
  priceQuartile: "τεταρτημόριο τιμής", // translated
  scoreLowestFirst: "Βαθμολογία (πρώτα η χαμηλότερη)", // translated
  scoreHighestFirst: "Βαθμολογία (πρώτα το υψηλότερο)", // translated
  priceLowestFirst: "Τιμή (πρώτα η χαμηλότερη)", // translated
  priceHighestFirst: "Τιμή (πρώτα η υψηλότερη)", // translated
  allPrices: "Όλες οι τιμές", // translated
  reserve: "Αποθεματικό", // translated
  dining: "Τραπεζαρία", // translated
};

export default restaurant;
